import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = false;

export const openDialogSbpSlice = createSlice({
 name: 'openDialogSbp',
 initialState,
 reducers: {
  openDialogSbp: (state, action: PayloadAction<boolean>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { openDialogSbp } = openDialogSbpSlice.actions;

export default openDialogSbpSlice.reducer;
